import { FormMessageType } from '@gn-audio/jss-core/common/enums/form-message.enum';

export interface IFormMessage {
  type: FormMessageType;
  controlName: string;
  propertyName: string;
  value: unknown;
}

export interface IFormField {
  valueField: {
    id: string;
    name: string;
  };
  model: {
    name: string;
    [key: string]: unknown;
  };
}

export const handleSetControlMessage = (event: MessageEvent, fields: IFormField[]) => {
  const message: IFormMessage = event.data;

  if (message.type !== FormMessageType.SetControl) {
    return;
  }

  SetControlValue(message.controlName, message.propertyName, message.value, fields);
};

export const getValueFieldByControlName = (controlName: string, fields: IFormField[]) => {
  const field = fields.find((f) => f.model.name === controlName);

  if (!field) {
    return;
  }

  return field.valueField;
};

export const SetControlValue = (
  controlName: string,
  propertyName: string,
  value: unknown,
  fields: IFormField[]
) => {
  const field = fields.find((f) => f.model.name === controlName);
  if (!field) {
    return;
  }
  field.model[propertyName] = value;
  const element = document.getElementById(field.valueField.id);

  if (element) {
    (element as any)[propertyName] = value;
  }
};
